import {IUOMConverter, IUOMConverterOptions} from "./PA.MD.Services.IF";
import * as hash from "object-hash";
import * as AsyncLock from "async-lock";
import {PlanVolumeConverter} from "../PA.TPM.Services/PlanVolumeConverter";

export class UOMConverterService
{
    private static dctConverterByIdOptionsHashId:
        {[converterId: string]: {[options_hash: string]: IUOMConverter}} = {}
    private static lock: AsyncLock = new AsyncLock()

    static async getConverter(converterId: string, options?: IUOMConverterOptions): Promise<IUOMConverter> {
        let opts: IUOMConverterOptions = options || {}
        let hashOpts = hash(JSON.stringify(opts), {algorithm: 'md5', })

        return await UOMConverterService.lock.acquire(hashOpts, (done) => {

            if (converterId in UOMConverterService.dctConverterByIdOptionsHashId) {
                if (hashOpts in UOMConverterService.dctConverterByIdOptionsHashId[converterId]) {
                    done(undefined, UOMConverterService.dctConverterByIdOptionsHashId[converterId][hashOpts])
                    return
                }
            } else {
                UOMConverterService.dctConverterByIdOptionsHashId[converterId] = {}
            }

            let returnValue: IUOMConverter = undefined
            let loadTask = []
            // Only know of one converter now
            switch (converterId){
                case "PlanVolumeConverter":
                    returnValue = new PlanVolumeConverter(opts)
                    loadTask.push(returnValue.OnLoadComplete)
                    break;
            }
            Promise.all(loadTask)
                .then((ignore) => {
                    UOMConverterService.dctConverterByIdOptionsHashId[converterId][hashOpts] = returnValue
                    done(undefined, returnValue)
                })
                .catch((err) => {
                    done(err)
                })

        })

    }

}